<app-banner></app-banner>

<section class="main-section register white-bg">
    <div class="width-container">
        <p [innerHtml]="'REGISTER.DESC' | translate:data"></p>
        <h2 [innerHtml]="'REGISTER.HEAD' | translate:data"></h2>
        <app-form></app-form>
        <p class="small-text" [innerHtml]="'REGISTER.FOOTNOTE' | translate:data"></p>
    </div>
</section>